import React from 'react';
import { socialLinks, coachCtaHref, playerCardPath } from '../../lib/publicProfile';

const LockIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff"
       strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="3" y="11" width="18" height="11" rx="2" />
    <path d="M7 11V7a5 5 0 0110 0v4" />
  </svg>
);

const CheckIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff"
       strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
       aria-hidden="true" className="ed-pp__coach-check">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const QrTileIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
       strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" />
    <rect x="3" y="14" width="7" height="7" /><line x1="14" y1="14" x2="21" y2="21" />
  </svg>
);

// Fixed dummies. The athlete's real score must never reach an anonymous
// client, so these are decorative and hidden from assistive tech.
const DUMMY_BARS = [
  { label: 'Speed', width: '82%' },
  { label: 'Explosion', width: '74%' },
  { label: 'Agility', width: '68%' },
];

const COACH_BULLETS = [
  'Verified measurable history with dates and combine context',
  'Contact, academic and transcript detail',
  'Complete film library and Power Score breakdown',
  'Side-by-side compare with your recruiting board',
];

export default function Rail({ athlete, isCoach }) {
  const a = athlete;
  const socials = socialLinks(a);
  const cardHref = playerCardPath(a);
  const gateHref = coachCtaHref(a, isCoach);

  return (
    <>
      {a.has_power_score && (
        <div className="ed-pp__score">
          <div className="ed-pp__score-cap">ProZpects Power Score</div>

          <div className="ed-pp__score-head">
            <span className="ed-pp__score-number" aria-hidden="true">87</span>
            <span className="ed-pp__score-lock"><LockIcon /></span>
          </div>

          {/* ed-pp__score-bars: Task 5 dropped this wrapper class as unused
              because no JSX referenced it yet. The design (Public Profile
              v2.dc.html) puts margin-top: 14px between the score row and this
              bar group, and with the bars in a bare unclassed div there is
              nothing to hang that rule on — so the class comes back here,
              paired with Editorial.css. */}
          <div className="ed-pp__score-bars" aria-hidden="true">
            {DUMMY_BARS.map(b => (
              <div key={b.label} className="ed-pp__score-bar">
                <span className="ed-pp__score-bar-label">{b.label}</span>
                <span className="ed-pp__score-track">
                  {/* Sole inline-style exception in this component: width is a
                      data-driven value from the fixed dummy bar list above,
                      not a value that belongs in a shared CSS class. */}
                  <span className="ed-pp__score-fill" style={{ width: b.width }} />
                </span>
              </div>
            ))}
          </div>

          <p className="ed-pp__score-body">
            A verified 0–100 athletic score with speed, explosion, agility and size
            sub-scores — visible to logged-in college coaches.
          </p>

          <a className="ed-pp__score-link" href={gateHref}>
            {isCoach ? 'View the full score →' : 'Coach login to view →'}
          </a>
        </div>
      )}

      {socials.length > 0 && (
        <section>
          <div className="ed-cap ed-cap--flush">
            <span className="ed-cap__label">Social</span>
          </div>
          <div className="ed-pp__social">
            {socials.map(s => (
              <a key={s.platform} href={s.href} target="_blank" rel="noopener noreferrer"
                 className="ed-pp__social-pill">
                {s.platform}: {s.label}
              </a>
            ))}
          </div>
        </section>
      )}

      <div className="ed-pp__card ed-pp__cardrow">
        <div className="ed-pp__cardrow-icon"><QrTileIcon /></div>
        <div className="ed-pp__cardrow-body">
          <div className="ed-pp__cardrow-title">Player Card</div>
          <div className="ed-pp__cardrow-sub">
            Print-ready card with a QR code that links back to this profile.
          </div>
        </div>
        <a href={cardHref} className="ed-pp__btn ed-pp__cardrow-btn">View</a>
      </div>

      <div className="ed-pp__coach">
        <div className="ed-pp__coach-cap">Are you a college coach?</div>
        <h3 className="ed-pp__coach-title">See the full recruiting file.</h3>
        <ul className="ed-pp__coach-list">
          {COACH_BULLETS.map(b => (
            <li key={b} className="ed-pp__coach-item"><CheckIcon />{b}</li>
          ))}
        </ul>
        <a href={gateHref}
           className="ed-pp__btn ed-pp__coach-btn">
          {isCoach ? 'Open the file' : 'Log in as a coach'}
        </a>
        <p className="ed-pp__coach-foot">
          Free for verified college staff · Redirects back here
        </p>
      </div>
    </>
  );
}
